
<template>
  <div class="image-container" ref="imageContainer">
    <div class="overlay-fondo"></div>

    <!-- 🌸 FLORES ABRAZANDO EL TARJETÓN -->
    <img src="@/assets/fl.png" class="flor flor-top-left" ref="florTLRef" alt="Flor adorno" />
    <img src="@/assets/fl.png" class="flor flor-bottom-right" ref="florBRRef" alt="Flor adorno" />

    <!-- 🖼️ TARJETÓN ELEGANTE MARFIL / LADEADO SUAVE -->
    <div ref="frameRef" class="frame-card">
      
      <!-- 📜 SELLO DE LACRE DORADO (lacre.png) -->
      <div ref="lacreRef" class="lacre-wrapper">
      </div>

      <!-- FOTO PRINCIPAL CON MARCO DELICADO -->
      <div class="photo-wrapper">
        <img
          ref="image"
          src="@/assets/_DSC1594_max_qualitynueva.webp"
          alt="Valerie Evangeline"
          class="cover-image"
        >
      </div>

      <!-- TEXTO FINO Y MENSAJE DE ESPERA -->
      <div ref="textRef" class="text-overlay">
        <p class="mensaje-invitacion">
          "Hay momentos inolvidables que se atesoran con el corazón. 
          ¡Me encantaría contar con tu presencia en este día tan especial!"
        </p>
        
        <div class="firma-wrapper">
          <span class="esperos-texto">Te espero para celebrar juntos</span>
          <h3 class="nombre-texto">Alexa Ontiveros</h3>
        </div>
      </div>

    </div>
  </div>
</template>

<script>
import { onMounted, ref } from 'vue'
import { gsap } from 'gsap'
import { ScrollTrigger } from 'gsap/ScrollTrigger'

gsap.registerPlugin(ScrollTrigger)

export default {
  name: 'CoverImageComponent',
  setup() {
    const image = ref(null)
    const textRef = ref(null)
    const imageContainer = ref(null)
    const frameRef = ref(null)
    const lacreRef = ref(null)
    const florTLRef = ref(null)
    const florBRRef = ref(null)

    onMounted(() => {
      ScrollTrigger.refresh()

      const tl = gsap.timeline({
        scrollTrigger: {
          trigger: imageContainer.value,
          start: 'top 75%',
          once: true
        }
      })

      // 1. Entrada suave del tarjetón blanco marfil ladeado (-2deg)
      tl.fromTo(
        frameRef.value,
        { opacity: 0, y: 60, scale: 0.92, rotate: -8 },
        { opacity: 1, y: 0, scale: 1, rotate: -2, duration: 1.2, ease: 'power3.out' }
      )

      // 2. Revelado de la foto
      .fromTo(
        image.value,
        { opacity: 0, scale: 1.1, filter: 'blur(4px)' },
        { opacity: 1, scale: 1, filter: 'blur(0px)', duration: 1, ease: 'power2.out' },
        '-=0.8'
      )

      // 3. Entrada del lacre en el centro con leve rebote
      .fromTo(
        lacreRef.value,
        { opacity: 0, scale: 0.2, y: -15 },
        { opacity: 1, scale: 1, y: 0, duration: 0.7, ease: 'back.out(2)' },
        '-=0.5'
      )

      // 4. Aparición de las flores de adorno
      .fromTo(
        [florTLRef.value, florBRRef.value],
        { opacity: 0, scale: 0.7, rotate: -15 },
        { opacity: 1, scale: 1, rotate: 0, duration: 0.9, stagger: 0.15, ease: 'back.out(1.4)' },
        '-=0.5'
      )

      // 5. Animación del texto fino
      .fromTo(
        textRef.value,
        { opacity: 0, y: 15 },
        { opacity: 1, y: 0, duration: 0.8, ease: 'power3.out' },
        '-=0.3'
      )
    })

    return { 
      textRef, 
      image, 
      imageContainer,
      frameRef,
      lacreRef,
      florTLRef,
      florBRRef
    }
  }
}
</script>

<style scoped>
/* ================= CONTENEDOR GENERAL ================= */
.image-container {
  width: 100%;
  min-height: 780px;
  position: relative;
  display: flex; background-image:
    linear-gradient(to bottom, rgba(182, 216, 240, 0.301), rgba(255, 255, 255, 0.288)),
    url('@/assets/b5da299ee9520960193643d003aa9e9c.jpg');

  background-size: cover;
  background-position: center;
  background-repeat: no-repeat;
  align-items: center;
  justify-content: center;
  padding: 60px 15px;
  overflow: hidden;
  box-sizing: border-box;
}

.overlay-fondo {
  position: absolute;
  inset: 0;
  z-index: 1;
}

/* ================= 🖼️ TARJETÓN CHIC FINO Y ELEGANTE ================= */
.frame-card {
  position: relative;
  z-index: 3;
  width: 90%;
  max-width: 420px;
  
  /* Color blanco marfil/papel artesanal fino */
  background: #fcfbfa;
  
  padding: 18px 18px 28px;
  border-radius: 20px;
  
  /* Detalle de doble filo fino y elegante */
  border: 1px solid rgba(225, 177, 68, 0.5);
  outline: 6px solid rgba(255, 255, 255, 0.15);
  
  /* Rotación delicada */
  transform: rotate(-2deg);
  
  /* Sombra flotante suave */
  box-shadow: 
    0 20px 45px rgba(0, 0, 0, 0.35),
    0 4px 10px rgba(0, 0, 0, 0.15);
    
  display: flex;
  flex-direction: column;
  align-items: center;
  margin: 10px auto;
}

/* CONTENEDOR DE FOTO CON LÍNEA MARGINAL */
.photo-wrapper {
  position: relative;
  width: 100%;
  height: 420px;
  border-radius: 12px;
  overflow: hidden;
  box-shadow: 0 4px 15px rgba(0,0,0,0.12);
}

.cover-image {
  width: 100%;
  height: 100%;
  object-fit: cover;
}

/* ================= 📜 SELLO DE LACRE DORADO ================= */
.lacre-wrapper {
  position: absolute;
  top: -26px;
  left: 50%;
  transform: translateX(-50%);
  z-index: 10;
}

.lacre-img {
  width: 58px;
  height: auto;
  filter: drop-shadow(0 4px 8px rgba(0, 0, 0, 0.35));
}

/* ================= 🌸 FLORES INTEGRADAS ================= */
.flor {
  position: absolute;
  z-index: 4;
  width: clamp(120px, 25vw, 170px);
  height: auto;
  pointer-events: none;
  filter: drop-shadow(0 8px 16px rgba(0, 0, 0, 0.3));
}

.flor-top-left {
  top: 30px;
  left: -25px;
  transform: rotate(-10deg);
}

.flor-bottom-right {
  bottom: 30px;
  right: -25px;
  transform: rotate(170deg);
}

/* ================= ✨ TEXTO Y MENSAJE DE ESPERA ================= */
.text-overlay {
  width: 100%;
  text-align: center;
  padding: 16px 10px 0;
  box-sizing: border-box;
}

.mensaje-invitacion {
  font-family: 'Playfair Display', serif;
  font-size: 16px !important;
  font-style: italic;
  color: #4a5d55;
  line-height: 1.5;
  margin: 0 0 14px 0;
}

.firma-wrapper {
  display: flex;
  flex-direction: column;
  align-items: center;
  gap: 2px;
  border-top: 1px solid rgba(225, 177, 68, 0.3);
  padding-top: 10px;
}

.esperos-texto {
  font-family: 'Josefin Sans', sans-serif;
  font-size: 12px;
  letter-spacing: 2px;
  text-transform: uppercase;
  color: #8c733e;
  font-weight: 600;
}

.nombre-texto {

   font-family: 'CynthiaJuneJF', cursive;
  font-size: 46px !important;
  background: linear-gradient(110deg, #a67c00 30%, #bf953f 45%, #ffffff 50%, #bf953f 55%, #a67c00 70%);
  background-size: 200% auto;
  -webkit-background-clip: text;
  background-clip: text;
  color: transparent;
  filter: drop-shadow(0px 2px 3px rgba(0,0,0,0.3));
  display: block;   font-size: 2.2rem;
  margin: 0;
  line-height: 1.1;
  text-shadow: 0 1px 2px rgba(225, 177, 68, 0.2);
}

</style>

```